import type { Config } from "../types/config";

export const DEFAULT_CONFIG: Config = {
  fixes: {
    langDir: {
      status: false,
    },
    removeTabIndex: {
      status: false,
    },
    removeTitleIfAccessibleName: {
      status: false,
    },
    forceUnderlineOnLinks: {
      status: false,
    },
    metaViewportScale: {
      status: false,
    },
    removeTargetBlank: {
      status: false,
    },
    addTargetBlankLabel: {
      status: false,
    },
    enableSkipLink: {
      status: false,
      targets: '',
    },
    addMissingCommentFormLabels: {
      status: false,
    },
    addMissingSearchFormLabels: {
      status: false,
    },
    addFocusOutline: {
      status: false,
    },
    addAccessibleNamesToInteractiveElements: {
      status: false,
    },
    addMissingAltTextToImages: {
      status: false,
    },
    addMissingTitlesToFrames: {
      status: false,
    },
  },

  // Toolbar configuration
  toolbar: {
    enabled: false,
    features: {
      fontSize: true,
      contrast: true,
      grayscale: true,
      hideOnSmallScreens: false,
    },
    settings: {
      fontSize: 14,
    },
    placement: {
      position: 'right',
      verticalOffset: 50,
    },
  },

  // Checker configuration
  checker: {
    enabled: false,
    placement: {
      position: 'right',
    },
  },
};
